module.exports = __webpack_public_path__ + "static/media/sologobranca.2c69f7d9.png";